import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateString, validateBoolean } from '/imports/validators';
import { strings } from '/imports/strings';

export interface Settings extends Doc {
  quoteRequestRecipients?: string; // comma-separated emails
  playwrightHeaded?: boolean;
  playwrightDisplayServer?: string; // X display for headed runs (e.g. '192.168.1.50:0'); empty → shared :99 (VNC)
  ceaPricingModelUrls?: string;
}
export type Model = Settings;

export const Settings = new Mongo.Collection<Settings>('settings');

export const settingsId = 'settings';
/** Fetch the singleton settings document. */
export const settings = async () => await Settings.findOneAsync(settingsId);

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: Settings,
  editableFields: [
    'quoteRequestRecipients', 'playwrightHeaded', 'playwrightDisplayServer', 'ceaPricingModelUrls',
  ],
  fieldLimits: {
    'ceaPricingModelUrls': 8192, 'playwrightDisplayServer': 256, 'quoteRequestRecipients': 4096,
  },
  listMethod: DeclareMethod<ListMethodArg<Settings>, ListMethodResponse<Settings, Refs>>('listSettings'),
  getMethod: DeclareMethod<string, GetMethodResponse<Settings, Refs>>('getSettings'),
  createMethod: DeclareMethod<Partial<Settings>, string>('createSettings'),
  updateMethod: DeclareMethod<Partial<Settings>, string>('updateSettings'),
  deleteMethod: DeclareMethod<string>('deleteSettings'),
  pathPrefix: '/settings',
  // icon: 'category' as IconKey,
  modelName: strings.Settings(),
  pluralName: strings.Settings(),
  validate: async (settings: Partial<Settings>) => {
    const errors: { [key: string]: string[] } = {};
    settings._id && validateString(errors, settings, '_id');
    validateString(errors, settings, 'quoteRequestRecipients');
    validateBoolean(errors, settings, 'playwrightHeaded');
    validateString(errors, settings, 'playwrightDisplayServer');
    validateString(errors, settings, 'ceaPricingModelUrls');
    return errors;
  },
};

Meteor.startup(async () => {
  if (Meteor.isClient) return;
  if (process.env.THREAD) return;
  const settings = await Settings.findOneAsync(settingsId);
  if (!settings) await Settings.insertAsync({ _id: settingsId });
});